import { render, staticRenderFns } from "./Dbaccess.vue?vue&type=template&id=7b7246e3&scoped=true&"
import script from "./Dbaccess.vue?vue&type=script&lang=js&"
export * from "./Dbaccess.vue?vue&type=script&lang=js&"
import style0 from "./Dbaccess.vue?vue&type=style&index=0&id=7b7246e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7246e3",
  null
  
)

export default component.exports